<template>
    <PopupRouterViewDetail label="Part Purchase Quality Control Confirmation Detail" @hideMethod="onHidden" :isShowCopyData="false">

        <!-- APP_DETAIL_HEADER -->

        <b-card header="Part Purchase Quality Control Confirmation" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="6">
						<!-- <app-input-combobox-autocomplete :options="partPurchaseQualityControls" optionsLabel="partPurchaseQualityControlDate" optionsKey="id" label-cols-lg="12" label="Part Purchase Quality Control" id="fieldset-part-purchase-quality-control" size="sm" :model.sync="model.partPurchaseQualityControlId"   :selected="model.partPurchaseQualityControl != null ? model.partPurchaseQualityControl.partPurchaseQualityControlDate : ''" @input="getPartPurchaseQualityControls" @change="updateData" :isEditable="false"  :isUpdatable="true"  :isSelectMethodExists="true" @onSelectMethod="setSelectedPartPurchaseQualityControl" /> -->
						<app-label label-cols-lg="12" size="sm" type="generatednumber" label="PQCC No" :model="model.partPurchaseQualityControlConfirmationNumber" />
						<app-input-datepicker  id="fieldset-part-purchase-quality-control-confirmation-date" label-cols-lg="12"  label="Date" size="sm" :model.sync="model.partPurchaseQualityControlConfirmationDate"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" :isEditable="false"  :isUpdatable="true" />
					</b-col>
					<b-col cols="12" lg="6">
				</b-col>

            </b-row>
        </b-card>

		<app-table-input-popup title="Part Purchase Quality Control Confirmation Detail" :bordered="true" :items="partPurchaseQualityControlConfirmationDetails" :fields="fieldsPartPurchaseQualityControlConfirmationDetail" :busy="isDataLoading" :sort-by.sync="sortByPartPurchaseQualityControlConfirmationDetail" :sort-desc.sync="sortDescPartPurchaseQualityControlConfirmationDetail" small responsive
			@editButtonMethod="editRowDataPartPurchaseQualityControlConfirmationDetail"
			@deleteButtonMethod="deleteRowDataPartPurchaseQualityControlConfirmationDetail"
			@showPopupAddMethod="resetDataPartPurchaseQualityControlConfirmationDetail()"
			@showPopupUploadMethod="showPopupUploadPartPurchaseQualityControlConfirmationDetail()"
			@downloadMethod="downloadPartPurchaseQualityControlConfirmationDetail()"
			@addFromClipboardMethod="addFromClipboardPartPurchaseQualityControlConfirmationDetail()"
			@replaceFromClipboardMethod="replaceFromClipboardPartPurchaseQualityControlConfirmationDetail()"
			:showActionButton="false"
			:showEditButton="false"
			:showDeleteButton="false"
			:showAddButton="false"
			:showAddFromClipboardButton="false"
			:showReplaceFromClipboardButton="false"
			:showUploadButton="false"
			:showDownloadButton="false"
			:isDownloadBusy="isDownloadPartPurchaseQualityControlConfirmationDetail"
			>
			<template #top-row v-if="isShowPartPurchaseQualityControlConfirmationDetailFilter">
				<b-th></b-th>
				<b-th></b-th>
				<b-th stacked-heading="Control Card">
					<v-select append-to-body label="controlCardNumber" :options="controlCards"  :value="filterPartPurchaseQualityControlConfirmationDetail.controlCardId" :reduce="item => item.id" v-model="filterPartPurchaseQualityControlConfirmationDetail.controlCardId" @search="getControlCards" :filterable="true"></v-select>
				</b-th>
				<b-th stacked-heading="Thickness">
					<b-form-input id="input-thickness-table" v-model="filterPartPurchaseQualityControlConfirmationDetail.thickness" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Width">
					<b-form-input id="input-width-table" v-model="filterPartPurchaseQualityControlConfirmationDetail.width" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Length">
					<b-form-input id="input-length-table" v-model="filterPartPurchaseQualityControlConfirmationDetail.length" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Qty">
					<b-form-input id="input-qty-table" v-model="filterPartPurchaseQualityControlConfirmationDetail.qty" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Karat">
					<b-form-checkbox id="input-karat-table" class="float-right" v-model="filterPartPurchaseQualityControlConfirmationDetail.karat"></b-form-checkbox>
				</b-th>
				<b-th stacked-heading="Retak">
					<b-form-checkbox id="input-retak-table" class="float-right" v-model="filterPartPurchaseQualityControlConfirmationDetail.retak"></b-form-checkbox>
				</b-th>
				<b-th stacked-heading="Goresan">
					<b-form-checkbox id="input-goresan-table" class="float-right" v-model="filterPartPurchaseQualityControlConfirmationDetail.goresan"></b-form-checkbox>
				</b-th>
				<b-th stacked-heading="Gelombang">
					<b-form-checkbox id="input-gelombang-table" class="float-right" v-model="filterPartPurchaseQualityControlConfirmationDetail.gelombang"></b-form-checkbox>
				</b-th>
				<b-th stacked-heading="Burry">
					<b-form-checkbox id="input-burry-table" class="float-right" v-model="filterPartPurchaseQualityControlConfirmationDetail.burry"></b-form-checkbox>
				</b-th>
				<b-th stacked-heading="Benjolan">
					<b-form-checkbox id="input-benjolan-table" class="float-right" v-model="filterPartPurchaseQualityControlConfirmationDetail.benjolan"></b-form-checkbox>
				</b-th>
				<b-th stacked-heading="Other Problem">
					<b-form-checkbox id="input-other-problem-table" class="float-right" v-model="filterPartPurchaseQualityControlConfirmationDetail.otherProblem"></b-form-checkbox>
				</b-th>
				<b-th stacked-heading="Ng Information">
					<b-form-input id="input-ng-information-table" v-model="filterPartPurchaseQualityControlConfirmationDetail.ngInformation" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Control Card Status">
					<v-select append-to-body label="name" :options="controlCardStatuss"  :value="filterPartPurchaseQualityControlConfirmationDetail.controlCardStatusId" :reduce="item => item.id" v-model="filterPartPurchaseQualityControlConfirmationDetail.controlCardStatusId" @search="getControlCardStatuss" :filterable="true"></v-select>
				</b-th>

				<b-th></b-th>
			</template>
			<template v-slot:cell(no)="row">
				{{ ((row.index + 1) + ( partPurchaseQualityControlConfirmationDetailPageSize * (currentPartPurchaseQualityControlConfirmationDetailPage - 1))) }}
			</template>
			<template v-slot:table-busys>
				<div class="text-center my-2">
					<b-spinner class="align-middle text-primary"></b-spinner>
					<strong class="ml-2">Loading...</strong>
				</div>
			</template>
			<template v-slot:cell(controlCard)="row">
				<app-input-combobox-autocomplete :options="controlCards" optionsLabel="controlCardNumber" optionsKey="id" :id="'input-part-purchase-quality-control-confirmation-detail-control-card-' + row.index" label-cols-lg="12" label="MCC" size="sm" :model.sync="row.item.controlCardId" :state="validateState('controlCardId')" :errorMessage="getErrorMessage(errorMessage.controlCardId, 'controlCardId')"  :selected="row.item.controlCard != null ? row.item.controlCard.controlCardNumber : ''"  @input="getControlCards" :loading="isControlCardComboLoading" :isEditable="false"  :isUpdatable="true"   :nolabel="true" />
			</template>
			<template v-slot:cell(part)="row">
				<app-label label-cols-lg="12" size="sm" label="Part" :model="(row.item.controlCard != null) ? ((row.item.controlCard.part != null) ? row.item.controlCard.part.partNumber + ' | ' + row.item.controlCard.part.partName : null) : null" />
			</template>
			<template v-slot:cell(partSpecificationQc)="row">
				<app-label label-cols-lg="12" size="sm" :model="row.item.partSpecificationQc" :isEditable="false"  :nolabel="true"/>
			</template>
			<template v-slot:cell(thickness)="row">
				<app-input-textbox :id="'input-part-purchase-quality-control-confirmation-detail-thickness-' + row.index" label-cols-lg="12" label="Thickness" size="sm" :model.sync="row.item.thickness"   :isEditable="false" :isUpdatable="true"   :nolabel="true" />
			</template>
			<template v-slot:cell(width)="row">
				<app-input-textbox :id="'input-part-purchase-quality-control-confirmation-detail-width-' + row.index" label-cols-lg="12" label="Width" size="sm" :model.sync="row.item.width"   :isEditable="false" :isUpdatable="true"   :nolabel="true" />
			</template>
			<template v-slot:cell(length)="row">
				<app-input-textbox :id="'input-part-purchase-quality-control-confirmation-detail-length-' + row.index" label-cols-lg="12" label="Length" size="sm" :model.sync="row.item.length"   :isEditable="false" :isUpdatable="true"   :nolabel="true" />
			</template>
			<template v-slot:cell(qty)="row">
				<app-input-textbox :id="'input-part-purchase-quality-control-confirmation-detail-qty-' + row.index" label-cols-lg="12" label="Qty" size="sm" :model.sync="row.item.qty"   :isEditable="false" :isUpdatable="true"   :nolabel="true" />
			</template>
			<template v-slot:cell(karat)="row">
				<app-input-checkbox :id="'input-part-purchase-quality-control-confirmation-detail-karat-row-' + row.index" label-cols-lg="12" label="Karat" :model.sync="row.item.karat" :isEditable="false" :isUpdatable="true"   :nolabel="true"></app-input-checkbox>
			</template>
			<template v-slot:cell(retak)="row">
				<app-input-checkbox :id="'input-part-purchase-quality-control-confirmation-detail-retak-row-' + row.index" label-cols-lg="12" label="Retak" :model.sync="row.item.retak" :isEditable="false" :isUpdatable="true"   :nolabel="true"></app-input-checkbox>
			</template>
			<template v-slot:cell(goresan)="row">
				<app-input-checkbox :id="'input-part-purchase-quality-control-confirmation-detail-goresan-row-' + row.index" label-cols-lg="12" label="Goresan" :model.sync="row.item.goresan" :isEditable="false" :isUpdatable="true"   :nolabel="true"></app-input-checkbox>
			</template>
			<template v-slot:cell(gelombang)="row">
				<app-input-checkbox :id="'input-part-purchase-quality-control-confirmation-detail-gelombang-row-' + row.index" label-cols-lg="12" label="Gelombang" :model.sync="row.item.gelombang" :isEditable="false" :isUpdatable="true"   :nolabel="true"></app-input-checkbox>
			</template>
			<template v-slot:cell(burry)="row">
				<app-input-checkbox :id="'input-part-purchase-quality-control-confirmation-detail-burry-row-' + row.index" label-cols-lg="12" label="Burry" :model.sync="row.item.burry" :isEditable="false" :isUpdatable="true"   :nolabel="true"></app-input-checkbox>
			</template>
			<template v-slot:cell(benjolan)="row">
				<app-input-checkbox :id="'input-part-purchase-quality-control-confirmation-detail-benjolan-row-' + row.index" label-cols-lg="12" label="Benjolan" :model.sync="row.item.benjolan" :isEditable="false" :isUpdatable="true"   :nolabel="true"></app-input-checkbox>
			</template>
			<template v-slot:cell(otherProblem)="row">
				<app-input-checkbox :id="'input-part-purchase-quality-control-confirmation-detail-other-problem-row-' + row.index" label-cols-lg="12" label="Other Problem" :model.sync="row.item.otherProblem" :isEditable="false" :isUpdatable="true"   :nolabel="true"></app-input-checkbox>
			</template>
			<template v-slot:cell(ngInformation)="row">
				<app-input-textarea :id="'input-part-purchase-quality-control-confirmation-detail-ng-information-' + row.index" label-cols-lg="12" label="Ng Information" size="sm" :model.sync="row.item.ngInformation"  :isEditable="false" :isUpdatable="true"   :nolabel="true" />
			</template>
			<template v-slot:cell(controlCardStatus)="row">
				<app-input-combobox-autocomplete :options="controlCardStatuss" optionsLabel="name" optionsKey="id" :id="'input-part-purchase-quality-control-confirmation-detail-control-card-status-' + row.index" label-cols-lg="12" label="Control Card Status" size="sm" :model.sync="row.item.controlCardStatusId"  :selected="row.item.controlCardStatus != null ? row.item.controlCardStatus.name : ''"  @input="getControlCardStatuss" :loading="isControlCardStatusComboLoading"  :isEditable="false" :isUpdatable="true"   :nolabel="true" />
			</template>
			<template v-slot:cell(id)="row">
				<b-button v-if="row.item.controlCardStatusId == 'NG'" :id="'input-part-purchase-quality-control-confirmation-detail-ng-information-' + row.index" @click="showImage(row.item)" size="sm" variant="primary">Show Image</b-button>
			</template>

			<template v-slot:form-add-detail>
				<PartPurchaseQualityControlConfirmationDetailInput 
					:openPopup="isShowPopupPartPurchaseQualityControlConfirmationDetail"
					:modelId="partPurchaseQualityControlConfirmationDetailId"
					@resetMethod="resetModal"
					@addButtonMethod="addRowDataPartPurchaseQualityControlConfirmationDetail"/>
			</template>
			<template v-slot:upload-detail>
				<PartPurchaseQualityControlConfirmationDetailUpload
					:openPopup="isShowPopupUploadPartPurchaseQualityControlConfirmationDetail"
					@resetMethod="resetModal"
					@uploadButtonMethod="uploadDataPartPurchaseQualityControlConfirmationDetail"
					:parentId="modelId"
					/>
			</template>
			<template #row-details="row">
				<b-card>
					<app-input-textbox :id="'input-part-purchase-quality-control-confirmation-detail-part-specification-qc-' + row.index" label-cols-lg="12" size="sm" :model.sync="row.item.partSpecificationQc"   :isUpdatable="false" :isEditable="false"  />
					<app-input-textbox :id="'input-part-purchase-quality-control-confirmation-detail-thickness-' + row.index" label-cols-lg="12" label="Thickness" size="sm" :model.sync="row.item.thickness"   :isUpdatable="false" :isEditable="false"  />
					<app-input-textbox :id="'input-part-purchase-quality-control-confirmation-detail-width-' + row.index" label-cols-lg="12" label="Width" size="sm" :model.sync="row.item.width"   :isUpdatable="false" :isEditable="false"  />
					<app-input-textbox :id="'input-part-purchase-quality-control-confirmation-detail-length-' + row.index" label-cols-lg="12" label="Length" size="sm" :model.sync="row.item.length"   :isUpdatable="false" :isEditable="false"  />
					<app-input-textbox :id="'input-part-purchase-quality-control-confirmation-detail-qty-' + row.index" label-cols-lg="12" label="Qty" size="sm" :model.sync="row.item.qty"   :isUpdatable="false" :isEditable="false"  />
					<app-input-checkbox :id="'input-part-purchase-quality-control-confirmation-detail-karat-row-' + row.index" label-cols-lg="12" label="Karat" :model.sync="row.item.karat" :isUpdatable="false" :isEditable="false" ></app-input-checkbox>
					<app-input-checkbox :id="'input-part-purchase-quality-control-confirmation-detail-retak-row-' + row.index" label-cols-lg="12" label="Retak" :model.sync="row.item.retak" :isUpdatable="false" :isEditable="false" ></app-input-checkbox>
					<app-input-checkbox :id="'input-part-purchase-quality-control-confirmation-detail-goresan-row-' + row.index" label-cols-lg="12" label="Goresan" :model.sync="row.item.goresan" :isUpdatable="false" :isEditable="false" ></app-input-checkbox>
					<app-input-checkbox :id="'input-part-purchase-quality-control-confirmation-detail-gelombang-row-' + row.index" label-cols-lg="12" label="Gelombang" :model.sync="row.item.gelombang" :isUpdatable="false" :isEditable="false" ></app-input-checkbox>
					<app-input-checkbox :id="'input-part-purchase-quality-control-confirmation-detail-burry-row-' + row.index" label-cols-lg="12" label="Burry" :model.sync="row.item.burry" :isUpdatable="false" :isEditable="false" ></app-input-checkbox>
					<app-input-checkbox :id="'input-part-purchase-quality-control-confirmation-detail-benjolan-row-' + row.index" label-cols-lg="12" label="Benjolan" :model.sync="row.item.benjolan" :isUpdatable="false" :isEditable="false" ></app-input-checkbox>
					<app-input-checkbox :id="'input-part-purchase-quality-control-confirmation-detail-other-problem-row-' + row.index" label-cols-lg="12" label="Other Problem" :model.sync="row.item.otherProblem" :isUpdatable="false" :isEditable="false" ></app-input-checkbox>
					<app-input-textarea :id="'input-part-purchase-quality-control-confirmation-detail-ng-information-' + row.index" label-cols-lg="12" label="Ng Information" size="sm" :model.sync="row.item.ngInformation"  :isUpdatable="false" :isEditable="false"  />
					<app-input-combobox-autocomplete :options="controlCardStatuss" optionsLabel="name" optionsKey="id" :id="'input-part-purchase-quality-control-confirmation-detail-control-card-status-' + row.index" label-cols-lg="12" label="Control Card Status" size="sm" :model.sync="row.item.controlCardStatusId"  :selected="row.item.controlCardStatus != null ? row.item.controlCardStatus.name : ''"  @input="getControlCardStatuss" :loading="isControlCardStatusComboLoading"  :isUpdatable="false" :isEditable="false"  />
				</b-card>
			</template>

		</app-table-input-popup>
        <!-- END_APP_DETAIL_HEADER -->
		<template #modal-left-button>
			<b-button size="sm" class="btn-default" @click="pritQcChecksheet">
					QC CheckSheet
			</b-button>
		</template>

        <b-overlay :show="isBusy" no-wrap></b-overlay>

		<PopupPDF :openPopup="isShowPopupPDF"
		:pdfUrl="pdfUrl"
		@resetModalMethod="resetModal"
		label="Image Evidence" />
    </PopupRouterViewDetail>
</template>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import PartPurchaseQualityControlConfirmation from '@/models/PartPurchaseQualityControlConfirmation/PartPurchaseQualityControlConfirmation';
import PartPurchaseQualityControlConfirmationList from '@/models/PartPurchaseQualityControlConfirmation/PartPurchaseQualityControlConfirmationList';
import PartPurchaseQualityControlConfirmationFilter from '@/filters/PartPurchaseQualityControlConfirmation/PartPurchaseQualityControlConfirmationFilter';

import PopupRouterViewDetail from '@/components/PopupRouterViewDetail';

import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import PartPurchaseQualityControl from '@/models/PartPurchaseQualityControl/PartPurchaseQualityControl';
import PartPurchaseQualityControlFilter from '@/filters/PartPurchaseQualityControl/PartPurchaseQualityControlFilter';
import AppLabel from '@/components/AppLabel';
import AppInputDatepicker from '@/components/AppInputDatepicker';
import AppInputDatepickerRange from '@/components/AppInputDatepickerRange';
import PartPurchaseQualityControlConfirmationDetail from '@/models/PartPurchaseQualityControlConfirmation/PartPurchaseQualityControlConfirmationDetail';
import PartPurchaseQualityControlConfirmationDetailFilter from '@/filters/PartPurchaseQualityControlConfirmation/PartPurchaseQualityControlConfirmationDetailFilter';
import ControlCard from '@/models/ControlCard/ControlCard';
import ControlCardFilter from '@/filters/ControlCard/ControlCardFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputCheckbox from '@/components/AppInputCheckbox';
import AppInputTextarea from '@/components/AppInputTextarea';
import ControlCardStatus from '@/models/ControlCardStatus/ControlCardStatus';
import ControlCardStatusFilter from '@/filters/ControlCardStatus/ControlCardStatusFilter';
import AppTableInput from '@/components/AppTableInput';
import AppTableInputPopup from '@/components/AppTableInputPopup';
import PartPurchaseQualityControlConfirmationDetailInput from '@/views/PartPurchaseQualityControlConfirmation/PartPurchaseQualityControlConfirmationDetailInput';
import PartPurchaseQualityControlConfirmationDetailUpload from '@/views/PartPurchaseQualityControlConfirmation/PartPurchaseQualityControlConfirmationDetailUpload';
import PopupRouterView from '@/components/PopupRouterView';
import PopupPDF from '@/components/PopupPDF';

export default {
	components : {
		AppInputComboboxAutocomplete,
		AppLabel,
		AppInputDatepicker,
		AppInputDatepickerRange,
		AppInputTextbox,
		AppInputCheckbox,
		AppInputTextarea,
		PartPurchaseQualityControlConfirmationDetailInput,PartPurchaseQualityControlConfirmationDetailUpload,
		AppTableInput,
		AppTableInputPopup,
		PopupRouterViewDetail,
		PopupRouterView,
		PopupPDF,
	},
	mixins : [validationMixin],
	validations: {
		model: {
		},
	},
	data() {
		return {
			errorMessage : {
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			fieldsPartPurchaseQualityControlConfirmationDetail: [
				// {"frontActions": { "class" : "th-actions", "label" : ""}},
				{"no" : { "class" : "th-number d-stack-none"}}, 
				{"controlCard": { "class" : "th-control-card first-child", "label" : "MCC", key: 'controlCard', sortable: false}}, 
				{"part": { "class" : "th-part first-child", "label" : "Part", key: 'part', sortable: true }}, 
				{"partSpecificationQc": { "class" : "th-part-specification-qc d-stack-none", "label" : "Part Specification Qc", key: 'partSpecificationQc', sortable: false}}, 
				{"thickness": { "class" : "th-thickness", "label" : "Thickness", key: 'thickness', sortable: false}}, 
				{"width": { "class" : "th-width last-child", "label" : "Width", key: 'width', sortable: false}}, 
				{"length": { "class" : "th-length d-stack-none", "label" : "Length", key: 'length', sortable: false}}, 
				{"qty": { "class" : "th-qty d-stack-none", "label" : "Qty", key: 'qty', sortable: false}}, 
				{"karat": { "class" : "th-karat d-stack-none", "label" : "Karat", key: 'karat', sortable: false}}, 
				{"retak": { "class" : "th-retak d-stack-none", "label" : "Retak", key: 'retak', sortable: false}}, 
				{"goresan": { "class" : "th-goresan d-stack-none", "label" : "Goresan", key: 'goresan', sortable: false}}, 
				{"gelombang": { "class" : "th-gelombang d-stack-none", "label" : "Gelombang", key: 'gelombang', sortable: false}}, 
				{"burry": { "class" : "th-burry d-stack-none", "label" : "Burry", key: 'burry', sortable: false}}, 
				{"benjolan": { "class" : "th-benjolan d-stack-none", "label" : "Benjolan", key: 'benjolan', sortable: false}}, 
				{"otherProblem": { "class" : "th-other-problem d-stack-none", "label" : "Other Problem", key: 'otherProblem', sortable: false}}, 
				{"ngInformation": { "class" : "th-ng-information d-stack-none", "label" : "Ng Information", key: 'ngInformation', sortable: false}}, 
				{"controlCardStatus": { "class" : "th-control-card-status d-stack-none", "label" : "Control Card Status", key: 'controlCardStatus', sortable: false}}, 
				{"id": { "class" :  "th-show-image d-stack-none", "label": "Evidence", key: 'id', sortable: false}},
				{"actions": { "class" : "th-actions d-stack-show", "label" : ""}}
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			modelPartPurchaseQualityControlConfirmationDetail : {},
			isShowPopupPartPurchaseQualityControlConfirmationDetail : false,
			isShowPopupUploadPartPurchaseQualityControlConfirmationDetail : false,
			filterPartPurchaseQualityControlConfirmation : null,
			currentPartPurchaseQualityControlConfirmationPage : 1,
			partPurchaseQualityControlConfirmationPageSize: 10,
			sortByPartPurchaseQualityControlConfirmation: '',
			sortDescPartPurchaseQualityControlConfirmation: '',
			filterPartPurchaseQualityControlConfirmationDetail : null,
			currentPartPurchaseQualityControlConfirmationDetailPage : 1,
			partPurchaseQualityControlConfirmationDetailPageSize: 10,
			sortByPartPurchaseQualityControlConfirmationDetail: '',
			sortDescPartPurchaseQualityControlConfirmationDetail: '',
			sortingByPartPurchaseQualityControlConfirmationDetail: [],
			partPurchaseQualityControlConfirmationDetails : [],
			partPurchaseQualityControlConfirmationDetailId : '',
			totalPartPurchaseQualityControlConfirmationDetailRow : 0,
			isShowPartPurchaseQualityControlConfirmationDetailFilter: false,
			isDownloadPartPurchaseQualityControlConfirmationDetail: false,
			controlCards: [],
			controlCardStatuss: [],
			partPurchaseQualityControls: [],
			partPurchaseQualityControls: [],
			isPartPurchaseQualityControlComboLoading: false,
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			isPartPurchaseQualityControlComboLoading: false,
			isControlCardComboLoading: false,
			isPartPurchaseQualityControlConfirmationComboLoading: false,
			isControlCardStatusComboLoading: false,
			isShowPopupPDF: false,
			isShowImageBusy: false,
			pdfUrl: '',
			isDownloadQcCheckSheet: true,
		}
	},
	methods : {
		pritQcChecksheet() {
			this.isDownloadQcCheckSheet = true;
			PartPurchaseQualityControlConfirmation.downloadQcChecksheet(this, this.modelId).then(result => {
				this.isDownloadQcCheckSheet = false;
			}).catch(error => { this.isDownloadQcCheckSheet = false; })
		},
		async showImage(item) {
			this.isShowPopupPDF = true;
			this.isShowImageBusy = true;

			const  result = await PartPurchaseQualityControlConfirmationDetail.showImageEvidence(this, item.id);
			if (!result) return;
			this.pdfUrl = result.download;
			this.isShowImageBusy = false;
		},
		getPartPurchaseQualityControlConfirmation : async function(id) {
			this.isBusy = true;
			PartPurchaseQualityControlConfirmation.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();


				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadPartPurchaseQualityControlConfirmation = true;
			this.filterPartPurchaseQualityControlConfirmation.id = this.modelId;
			PartPurchaseQualityControlConfirmation.downloadDataDetail(this, this.filterPartPurchaseQualityControlConfirmation).then(result => {
				this.isDownloadPartPurchaseQualityControlConfirmation = false;
			}).catch(error => { this.isDownloadPartPurchaseQualityControlConfirmation = false; })
		},
		getPartPurchaseQualityControlConfirmationDetails : async function(isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterPartPurchaseQualityControlConfirmationDetail);
			if (this.modelId == null) return;
			filter.partPurchaseQualityControlConfirmationId = this.modelId;
			filter.draftMode = "0";
			if (this.sortByPartPurchaseQualityControlConfirmationDetail != null) {
				this.sortingByPartPurchaseQualityControlConfirmationDetail[this.sortByPartPurchaseQualityControlConfirmationDetail] = this.sortDescPartPurchaseQualityControlConfirmationDetail;
			}
			let currentPage = (this.currentPartPurchaseQualityControlConfirmationDetailPage - 1);
			if (isAddRow) {
				let totalData = this.totalPartPurchaseQualityControlConfirmationDetailRow + 1;
				let page = Math.ceil(totalData/this.partPurchaseQualityControlConfirmationDetailPageSize);
				currentPage = page - 1;
			}
			// disable paging start
			currentPage = null;
			this.partPurchaseQualityControlConfirmationDetailPageSize = 0;
			// disable paging end
			PartPurchaseQualityControlConfirmationDetail.getList(this, filter, this.sortingByPartPurchaseQualityControlConfirmationDetail, currentPage , this.partPurchaseQualityControlConfirmationDetailPageSize).then(result => {
				this.currentPartPurchaseQualityControlConfirmationDetailPage = currentPage + 1;
				this.partPurchaseQualityControlConfirmationDetails = result.data;
				this.totalPartPurchaseQualityControlConfirmationDetailRow = result.dataCount;
			}).catch(error => {});
		},
		getPartPurchaseQualityControlConfirmations : async function(input) {
			let filter = new PartPurchaseQualityControlConfirmationFilter();
			if (input != undefined) {
				filter.PartPurchaseQualityControlConfirmationNumber = input;
			}
			this.isPartPurchaseQualityControlConfirmationComboLoading = true;
			PartPurchaseQualityControlConfirmation.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.partPurchaseQualityControlConfirmations = result.data
				}
				this.isPartPurchaseQualityControlConfirmationComboLoading = false;
			})
			.catch(error => {});
		},
		getControlCards : async function(input) {
			let filter = new ControlCardFilter();
			if (input != undefined) {
				filter.controlCardNumber = input;
			}
			this.isControlCardComboLoading = true;
			ControlCard.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.controlCards = result.data
				}
				this.isControlCardComboLoading = false;
			})
			.catch(error => {});
		},
		getPartPurchaseQualityControlConfirmations : async function(input) {
			let filter = new PartPurchaseQualityControlConfirmationFilter();
			if (input != undefined) {
				filter.partPurchaseQualityControlConfirmationNumber = input;
			}
			this.isPartPurchaseQualityControlConfirmationComboLoading = true;
			PartPurchaseQualityControlConfirmation.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.partPurchaseQualityControlConfirmations = result.data
				}
				this.isPartPurchaseQualityControlConfirmationComboLoading = false;
			})
			.catch(error => {});
		},
		getControlCardStatuss : async function(input) {
			let filter = new ControlCardStatusFilter();
			if (input != undefined) {
				filter.name = input;
			}
			this.isControlCardStatusComboLoading = true;
			ControlCardStatus.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.controlCardStatuss = result.data
				}
				this.isControlCardStatusComboLoading = false;
			})
			.catch(error => {});
		},
		getPartPurchaseQualityControls : async function(input) {
			let filter = new PartPurchaseQualityControlFilter();
			if (input != undefined) {
				filter.partPurchaseQualityControlDate = input;
			}
			filter.fwDocStat = '0,1';
			filter.exactType.fwDocStat = '1';
			PartPurchaseQualityControl.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.partPurchaseQualityControls = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedPartPurchaseQualityControlExecuted(item) {
			let _this = this;
			if(item == undefined || item == null) {
				this.model.partPurchaseQualityControlId = null;
				this.model.partPurchaseQualityControl = null;
				this.isBusy = true;
				PartPurchaseQualityControlConfirmation.resetDocument(this, this.model.id).then(result => {
					this.getPartPurchaseQualityControlConfirmation(this.model.id).then(result => {
						this.getPartPurchaseQualityControlConfirmationDetails();
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}).catch(error => { this.isBusy = false; });
			} else {
				this.model.partPurchaseQualityControlId = item.id;
				this.model.partPurchaseQualityControl = item;

				this.isBusy = true;
				PartPurchaseQualityControlConfirmation.copyFromDocument(this, 'partpurchasequalitycontrol', item.id, this.model.id).then(result => {
					this.getPartPurchaseQualityControlConfirmation(this.model.id).then(result => {
						this.getPartPurchaseQualityControlConfirmationDetails();
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}).catch(error => { this.isBusy = false; });
			}
		},
		setSelectedPartPurchaseQualityControl(item) {
			if(item) {
				var itemId = Number(item.id);
				if(this.model.partPurchaseQualityControlId == itemId) return;
			}

			if(this.partPurchaseQualityControlConfirmationDetails != null && this.partPurchaseQualityControlConfirmationDetails.length > 0) {
				const msg = this.$createElement;
				const msgNode = msg('div', {
					domProps: {
						innerHTML: '<p>Perubahan terhadap Part Purchase Quality Control Confirmation akan me-reset form yang sudah diinput sebelumnya.</p><p>Apakah anda yakin akan melanjutkan?</p>'
					}
				});
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Confirmation',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'danger',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				})
				.then(value => {
					if (value) {
						this.setSelectedPartPurchaseQualityControlExecuted(item);
					}
				})
				.catch(err => {})
			} else {
				this.setSelectedPartPurchaseQualityControlExecuted(item);
			}
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.partPurchaseQualityControlConfirmationInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				if (id != '' && id != null && id != undefined) {
					PartPurchaseQualityControlConfirmation.commitData(this, model, id).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'partpurchasequalitycontrolconfirmationindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				} else {
					PartPurchaseQualityControlConfirmation.insertData(this, model).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'partpurchasequalitycontrolconfirmationindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					PartPurchaseQualityControlConfirmation.updateDataDetail(this, model, id)
					.catch((error) => {
						this.getPartPurchaseQualityControlConfirmation(id);
					});
				}
			});
		},
		onHidden() {
			this.getPartPurchaseQualityControlConfirmations();
		},
		addRowDataPartPurchaseQualityControlConfirmationDetail(modalEvent, model) {
			if (model != null) {
				if (model.id != null && model.id != '') {
					model.partPurchaseQualityControlConfirmationId =  this.modelId;
					PartPurchaseQualityControlConfirmationDetail.updateDataDetail(this, model, model.id)
					.then(result => {
						this.getPartPurchaseQualityControlConfirmationDetails(true);
						this.isShowPopupPartPurchaseQualityControlConfirmationDetail = false;
					})
				} else {
					model.partPurchaseQualityControlConfirmationId =  this.modelId;
					PartPurchaseQualityControlConfirmationDetail.createDataDetail(this, model)
					.then(result => {
						this.getPartPurchaseQualityControlConfirmationDetails(true);
						this.isShowPopupPartPurchaseQualityControlConfirmationDetail = false;
					})
				}
			}
		},
		async editRowDataPartPurchaseQualityControlConfirmationDetail(id) {
			this.partPurchaseQualityControlConfirmationDetailId = id;
			this.isShowPopupPartPurchaseQualityControlConfirmationDetail = true; 
		},
		async deleteRowDataPartPurchaseQualityControlConfirmationDetail(id) {
			PartPurchaseQualityControlConfirmationDetail.deleteData(this, id).then(result => { this.getPartPurchaseQualityControlConfirmationDetails(); });
		},
		async resetDataPartPurchaseQualityControlConfirmationDetail() {
			this.partPurchaseQualityControlConfirmationDetailId = "";
			this.isShowPopupPartPurchaseQualityControlConfirmationDetail = true;
		},
		async addDataPartPurchaseQualityControlConfirmationDetail() {
			PartPurchaseQualityControlConfirmationDetail.createData(this, { partPurchaseQualityControlConfirmationId: this.modelId })
			.then(result => {
				this.getPartPurchaseQualityControlConfirmationDetails(true);
			})
		},
		async addFromClipboardPartPurchaseQualityControlConfirmationDetail() {
			let controlCards = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					controlCards.push({ controlCard: item, partPurchaseQualityControlConfirmationId: this.modelId });
				});
				PartPurchaseQualityControlConfirmationDetail.addFromClipboard(this, controlCards).then(result => { this.getPartPurchaseQualityControlConfirmationDetails() });
			});
		},
		async replaceFromClipboardPartPurchaseQualityControlConfirmationDetail() {
			let controlCards = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					controlCards.push({ controlCard: item, partPurchaseQualityControlConfirmationId: this.modelId });
				});
				PartPurchaseQualityControlConfirmationDetail.replaceFromClipboard(this, controlCards).then(result => { this.getPartPurchaseQualityControlConfirmationDetails() });
			});   
		},
		showPopupUploadPartPurchaseQualityControlConfirmationDetail() {
			if(this.partPurchaseQualityControlConfirmationDetails != null && this.partPurchaseQualityControlConfirmationDetails.length > 0) {
				const msg = this.$createElement;
				const msgNode = msg('div', {
					domProps: {
						innerHTML: '<p>Perubahan terhadap PartPurchaseQualityControlConfirmationDetail akan me-reset data yang sudah diinput sebelumnya.</p><p>Apakah anda yakin akan melanjutkan?</p>'
					}
				});
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Confirmation',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'danger',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				})
				.then(value => {
					if (value) {
						this.isShowPopupUploadPartPurchaseQualityControlConfirmationDetail = true;
					}
				})
				.catch(err => {})
			} else {
				this.isShowPopupUploadPartPurchaseQualityControlConfirmationDetail = true;
			}
		},
		uploadDataPartPurchaseQualityControlConfirmationDetail(modalEvent, newDatas) {
			this.isShowPopupUploadPartPurchaseQualityControlConfirmationDetail = false; 
		},
		downloadPartPurchaseQualityControlConfirmationDetail(modalEvent) {
			this.isDownloadPartPurchaseQualityControlConfirmationDetail = true;
			this.filterPartPurchaseQualityControlConfirmationDetail.partPurchaseQualityControlConfirmationId = this.modelId;
			PartPurchaseQualityControlConfirmationDetail.downloadDataDetail(this, this.filterPartPurchaseQualityControlConfirmationDetail).then(result => {
				this.isDownloadPartPurchaseQualityControlConfirmationDetail = false;
			}).catch(error => { this.isDownloadPartPurchaseQualityControlConfirmationDetail = false; })
		},
		saveInputPartPurchaseQualityControlConfirmationDetail(item) {
			if (this.controlCards != null && this.controlCards != undefined  && this.controlCards.length > 0) {
				item.controlCard = this.controlCards.find(q => q.id == item.controlCardId);
			}
			if (this.partPurchaseQualityControlConfirmations != null && this.partPurchaseQualityControlConfirmations != undefined  && this.partPurchaseQualityControlConfirmations.length > 0) {
				item.partPurchaseQualityControlConfirmation = this.partPurchaseQualityControlConfirmations.find(q => q.id == item.partPurchaseQualityControlConfirmationId);
			}
			if (this.controlCardStatuss != null && this.controlCardStatuss != undefined  && this.controlCardStatuss.length > 0) {
				item.controlCardStatus = this.controlCardStatuss.find(q => q.id == item.controlCardStatusId);
			}

			let id = item.id;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					PartPurchaseQualityControlConfirmationDetail.updateDataDetail(this, item, item.id);
				}
			});
		},
		resetModal(modalType) {
			this.isShowPopupUploadPartPurchaseQualityControlConfirmationDetail = false; 
			this.isShowPopupPartPurchaseQualityControlConfirmationDetail = false; 
			if (modalType == 'PartPurchaseQualityControlConfirmationDetail') {
				this.getPartPurchaseQualityControlConfirmationDetails();
			}
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
				//this.isShowPartPurchaseQualityControlConfirmationDetailFilter = true;
			}
		},
	},
	beforeMount() {
		this.filterPartPurchaseQualityControlConfirmation = new PartPurchaseQualityControlConfirmationFilter();
		this.filterPartPurchaseQualityControlConfirmationDetail = new PartPurchaseQualityControlConfirmationDetailFilter();
		//this.getControlCards();
		//this.getPartPurchaseQualityControlConfirmations();
		//this.getControlCardStatuss();
		//this.getPartPurchaseQualityControls();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getPartPurchaseQualityControlConfirmation(id);
			} else {
				this.modelId = id;
				this.getPartPurchaseQualityControlConfirmation(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
		isAllowSaveDraft: {
			get: function() {
				if(this.model.mainRecordId != undefined || this.model.mainRecordId != null) return false;
				return true;
			}
		}
	},
	watch : {
		sortByPartPurchaseQualityControlConfirmationDetail : {
			handler: function() {
				this.getPartPurchaseQualityControlConfirmationDetails();
			}
		},
		sortDescPartPurchaseQualityControlConfirmationDetail: {
			handler: function() {
				this.getPartPurchaseQualityControlConfirmationDetails();
			}
		},
		currentPartPurchaseQualityControlConfirmationDetailPage: {
			handler: function() {
				this.getPartPurchaseQualityControlConfirmationDetails();
			}
		},
		partPurchaseQualityControlConfirmationDetailPageSize : {
			handler: function() {
				this.getPartPurchaseQualityControlConfirmationDetails();
			}
		},
		filterPartPurchaseQualityControlConfirmationDetail: {
			handler: function() {
				this.getPartPurchaseQualityControlConfirmationDetails();
			},
			deep: true,
		},
	},
}
</script>
